import React from 'react'
import { Switch, Redirect, useLocation } from 'react-router-dom'
import {
  useUserService,
  simple360Url,
  coachRecommendsUrl,
  leaderAssessmentsUrl,
} from '@abroad/components'
import PrivateRoute from './PrivateRoute'
import {
  NoAwarenessAssessment,
  PersonalSurveyResult,
  SurveyComparison,
  Home,
  MediaInfo,
  Favorites,
  Profile,
  SurveyCategory,
  MediaLibrary,
  NotFound,
  UserPayment,
  UnsubscribeEmail,
  UnderMaintenance,
  Program,
  ProgramsOverview,
  Simple360,
  LeaderAssessments,
  JourneysWrapper,
  GrowthPlan,
  Intention,
  LAResults,
  AskQuestion,
  DownloadApp,
  GlobalJournal,
  CoachingProvider,
  SessionDetails,
  UpgradeInquiry,
  CoachingPlanPayment,
  ChangeCard,
  Quests,
  BeginWisdomAssessment,
  BeginProsperityAssessment,
  WisdomAssessmentResult,
  ProsperityAssessmentResult,
  CoachAndCircles,
  ProsperityComparison,
  UserPlansAndPayments,
  QuestPaymentStatus,
  EnrollTypeFormAnswer,
  RescheduleSession,
  ScheduleRemainingSessions,
  QuestRescheduleSession,
  QuestSessionList,
} from '../pages'
import { FAQsListing, ModuleDetails, ScheduledDetail } from '../components'
import { Layout, MediaControlWrapper } from '../components/layout'
import Gallery from '../components/quests/Gallery'
import {
  IntentionQuest,
  QuestsFaculty,
  UpcomingQuests,
  QuestYourHome,
  YourQuestsToDo,
  QuestAllIntention,
  QuestsIntention,
  QuestsItinerary,
  QuestsLearningResourcesBlog,
  QuestsLearningResourcesAudio,
  QuestsLearningResourcesVideo,
  QuestsLearningResourcesBlogDetails,
  QuestPayment,
  QuestTravelDocument,
} from '../components/quests'
import { FirstSessionSchedule } from '../components/sessions'
import IndividualSessionScheduling from '../components/circles/IndividualSessionScheduling'
// import BookCircleModal from '../components/circles/BookCircleModal'

/**
 * Navigaton routes for the app
 *
 * @info [react-router-dom](https://reactrouter.com/web/guides/quick-start)
 */
const AuthenticatedRoutes = () => {
  const { user } = useUserService()
  const location = useLocation()

  return (
    <>
      {/* <BookCircleModal user={user} /> */}
      <Switch>
        <PrivateRoute exact path='/404' component={NotFound} />
        <PrivateRoute
          exact
          path='/under-maintenance'
          component={UnderMaintenance}
        />
        <PrivateRoute
          exact
          path='/email/unsubscribe'
          component={UnsubscribeEmail}
        />
        <MediaControlWrapper>
          <Switch>
            <PrivateRoute
              path='/media/:mediaCategory/:categoryId/:mediaId'
              component={MediaInfo}
            />
            <PrivateRoute
              path={[
                '/survey',
                '/survey/comparison-report',
                '/survey/:id',
                '/survey/leader/:id',
                '/survey/category/:category',
                '/module/:programId/:moduleId',
                '/breakthrough',
                '/programs',
                '/program/:programId',
                '/media-library/:id?',
                '/home',
                '/home/purpose-vision',
                '/home/values-principles',
                '/favorites',
                '/user-payment',
                '/on-demand',
                '/Profile',
                '/Profile/update-password',
                '/plans-payments',
                '/coaching',
                '/coaching/intentions',
                '/coaching/intentions/:intentionId',
                '/coaching/sessions',
                '/coaching/session/:sessionId',
                '/coaching/objectives',
                `/survey/requests/${leaderAssessmentsUrl}`,
                `/survey/requests/${leaderAssessmentsUrl}/:id`,
                `/survey/requests/${simple360Url}`,
                `/${coachRecommendsUrl}`,
                '/ask-question',
                '/download-app',
                '/journal',
                '/journal/:categoryType/:subCategoryId/:mediaId',
                '/upgrade-inquiry',
                '/plans-payments/coaching-plan/:coachingPlanId',
                '/plans-payments/coaching-plan/:coachingPlanId/card/:cardId/change-card',
                '/experiences',
                '/your-experiences',
                '/your-experiences/:questId/todos',
                '/your-experiences/:blogId/blog-detail',
                '/your-experiences/:questId/faculties',
                '/your-experiences/:questId/intentions',
                '/your-experiences/:questId/intentions/:intentionId',
                '/your-experiences/:questId/itinrary',
                '/your-experiences/:questId/travel-documents',
                '/your-experiences/:questId/payment-status',
                '/quests/:questId/public',
                '/wisdom',
                '/wisdom/:id',
                '/wisdom/comparison-report',
                '/prosperity',
                '/prosperity/:id',
                '/prosperity/comparison-report',
                '/faqs',
                '/schedule-session',
                '/schedule-session/individual',
                '/schedule-detail',
                '/coaching/sessions/upcoming/first-session',
                '/coaching/sessions/schedule-remaining',
                '/coaching/sessions/reschedule',
                '/your-experiences/:questId/payments',
              ]}>
              <Layout>
                <Switch>
                  <PrivateRoute
                    path={`/survey`}
                    component={NoAwarenessAssessment}
                    exact
                  />
                  <PrivateRoute
                    path={[`/survey/requests/${simple360Url}`]}
                    component={Simple360}
                    exact
                  />
                  <PrivateRoute
                    path={[
                      `/survey/requests/${leaderAssessmentsUrl}`,
                      `/survey/requests/${leaderAssessmentsUrl}/:id`,
                    ]}
                    component={LeaderAssessments}
                    exact
                  />
                  <PrivateRoute
                    exact
                    path={`/survey/comparison-report`}
                    component={SurveyComparison}
                  />
                  <PrivateRoute
                    exact
                    path={`/survey/:id`}
                    component={PersonalSurveyResult}
                  />
                  <PrivateRoute
                    exact
                    path={`/survey/leader/:id`}
                    component={LAResults}
                  />
                  <PrivateRoute
                    exact
                    path={`/survey/category/:category`}
                    component={SurveyCategory}
                  />
                  <PrivateRoute
                    path='/module/:programId/:moduleId'
                    component={ModuleDetails}
                  />
                  <PrivateRoute
                    exact
                    path='/program/:programId'
                    component={Program}
                  />
                  <PrivateRoute
                    exact
                    path='/programs'
                    component={ProgramsOverview}
                  />
                  <PrivateRoute
                    exact
                    path='/media-library/:id?'
                    component={MediaLibrary}
                  />
                  <PrivateRoute
                    exact
                    path={[
                      '/home',
                      '/home/purpose-vision',
                      '/home/values-principles',
                    ]}
                    component={Home}
                  />
                  <PrivateRoute path='/favorites' component={Favorites} />
                  <PrivateRoute
                    exact
                    path='/user-payment'
                    component={UserPayment}
                  />
                  <PrivateRoute
                    path='/plans-payments/coaching-plan/:coachingPlanId'
                    component={CoachingPlanPayment}
                    exact
                  />
                  <PrivateRoute
                    path='/plans-payments/coaching-plan/:coachingPlanId/card/:cardId/change-card'
                    component={ChangeCard}
                    exact
                  />
                  <PrivateRoute
                    path={[`/Profile`, '/profile/my-information']}
                    component={Profile}
                    exact
                  />
                  <PrivateRoute
                    path='/plans-payments'
                    component={UserPlansAndPayments}
                    exact
                  />
                  <PrivateRoute
                    exact
                    path={`/Profile/update-password`}
                    component={Profile}
                  />
                  <PrivateRoute
                    exact
                    path={`/coaching/intentions`}
                    component={GrowthPlan}
                  />
                  <PrivateRoute
                    exact
                    path={`/coaching/intentions/:intentionId`}
                    component={Intention}
                  />
                  <PrivateRoute
                    exact
                    path={[
                      `/coaching/sessions`,
                      `/coaching/sessions/upcoming`,
                      `/coaching/sessions/completed`,
                    ]}
                    component={CoachingProvider}
                  />
                  <PrivateRoute
                    exact
                    path={`/coaching/session/:sessionId`}
                    component={SessionDetails}
                  />
                  <PrivateRoute
                    exact
                    path={`/${coachRecommendsUrl}`}
                    component={JourneysWrapper}
                  />
                  <PrivateRoute
                    exact
                    path={`/experiences`}
                    component={Quests}
                  />
                  <PrivateRoute
                    exact
                    path={`/your-experiences`}
                    component={QuestYourHome}
                  />

                  <PrivateRoute
                    exact
                    path={`/quests/:questId/gallery`}
                    component={Gallery}
                  />
                  <PrivateRoute
                    exact
                    path={'/quests/:questId/public'}
                    component={UpcomingQuests}
                  />
                  <PrivateRoute
                    exact
                    path={'/your-experiences/:questId/todos'}
                    component={YourQuestsToDo}
                  />
                  <PrivateRoute
                    exact
                    path={'/your-experiences/:blogId/blog-detail'}
                    component={QuestsLearningResourcesBlogDetails}
                  />
                  <PrivateRoute
                    exact
                    path={'/your-experiences/:questId/faculties'}
                    component={QuestsFaculty}
                  />
                  <PrivateRoute
                    exact
                    path={'/your-experiences/:questId/intentions'}
                    component={QuestsIntention}
                  />
                  <PrivateRoute
                    exact
                    path={'/your-experiences/:questId/all-intentions'}
                    component={QuestAllIntention}
                  />
                  <PrivateRoute
                    exact
                    path={'/your-experiences/:questId/intentions/:intentionId'}
                    component={IntentionQuest}
                  />
                  <PrivateRoute
                    exact
                    path={'/your-experiences/:questId/itinrary'}
                    component={QuestsItinerary}
                  />
                  <PrivateRoute
                    exact
                    path={'/your-experiences/:questId/audio'}
                    component={QuestsLearningResourcesAudio}
                  />
                  <PrivateRoute
                    exact
                    path={'/your-experiences/:questId/video'}
                    component={QuestsLearningResourcesVideo}
                  />
                  <PrivateRoute
                    exact
                    path={'/your-experiences/:questId/read'}
                    component={QuestsLearningResourcesBlog}
                  />
                  <PrivateRoute
                    path='/your-experiences/:questId/payments'
                    component={QuestPayment}
                    exact
                  />
                  <PrivateRoute
                    path='/your-experiences/:questId/payment-status'
                    component={QuestPaymentStatus}
                    exact
                  />
                  <PrivateRoute
                    path='/your-experiences/:questId/typeform/:questCustomFormId/answer'
                    component={EnrollTypeFormAnswer}
                  />
                  <PrivateRoute
                    exact
                    path='/your-experiences/:questId/travel-documents'
                    component={QuestTravelDocument}
                  />
                  <PrivateRoute
                    exact
                    path='/your-experiences/:questId/session-list'
                    component={QuestSessionList}
                  />
                  <PrivateRoute
                    exact
                    path='/your-experiences/:questId/reschedule-session'
                    component={QuestRescheduleSession}
                  />
                  <PrivateRoute
                    exact
                    path='/ask-question'
                    component={AskQuestion}
                  />
                  <PrivateRoute
                    exact
                    path='/download-app'
                    component={DownloadApp}
                  />
                  <PrivateRoute
                    exact
                    path={[
                      `/journal`,
                      '/journal/:categoryType/:subCategoryId/:mediaId',
                    ]}
                    component={GlobalJournal}
                  />
                  <PrivateRoute
                    path='/upgrade-inquiry'
                    component={UpgradeInquiry}
                  />
                  <PrivateRoute
                    path='/schedule-session'
                    component={CoachAndCircles}
                    exact
                  />
                  <PrivateRoute
                    path='/coaching/sessions/upcoming/first-session'
                    component={FirstSessionSchedule}
                    exact
                  />
                  <PrivateRoute
                    path='/coaching/sessions/schedule-remaining'
                    component={ScheduleRemainingSessions}
                    exact
                  />
                  <PrivateRoute
                    path='/coaching/sessions/reschedule'
                    component={RescheduleSession}
                    exact
                  />
                  <PrivateRoute path='/faqs' component={FAQsListing} exact />
                  <PrivateRoute
                    path='/schedule-session/individual'
                    component={IndividualSessionScheduling}
                    exact
                  />
                  <PrivateRoute
                    exact
                    path='/schedule-detail'
                    component={ScheduledDetail}
                  />
                  <PrivateRoute
                    path='/wisdom/comparison-report'
                    component={SurveyComparison}
                    exact
                  />
                  {user &&
                    user.wisdomTaken === false &&
                    location.pathname.startsWith('/wisdom') && (
                      <Redirect to='/home' />
                    )}
                  <PrivateRoute
                    path='/wisdom'
                    component={BeginWisdomAssessment}
                    exact
                  />
                  <PrivateRoute
                    path='/wisdom/:id'
                    component={WisdomAssessmentResult}
                    exact
                  />
                  <PrivateRoute
                    path='/prosperity/comparison-report'
                    component={ProsperityComparison}
                    exact
                  />
                  <PrivateRoute
                    path='/prosperity'
                    component={BeginProsperityAssessment}
                    exact
                  />
                  <PrivateRoute
                    path='/prosperity/:id'
                    component={ProsperityAssessmentResult}
                    exact
                  />
                  {user ? (
                    <Redirect to='/home' />
                  ) : (
                    <Redirect
                      to={`/${location?.search ? location?.search : ''}`}
                    />
                  )}
                </Switch>
              </Layout>
            </PrivateRoute>
            {user ? (
              <Redirect to='/home' />
            ) : (
              <Redirect to={`/${location?.search ? location?.search : ''}`} />
            )}
          </Switch>
        </MediaControlWrapper>
      </Switch>
    </>
  )
}

export default AuthenticatedRoutes
